var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopComputer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.15 5A2.85 2.85 0 0 1 5 2.15h14A2.85 2.85 0 0 1 21.85 5v10A2.85 2.85 0 0 1 19 17.85h-3.661l.428 1.715.834.834A.85.85 0 0 1 16 21.85H8a.85.85 0 0 1-.601-1.451l.833-.834.43-1.715H5A2.85 2.85 0 0 1 2.15 15zm1.7 8.85V15c0 .635.515 1.15 1.15 1.15h14A1.15 1.15 0 0 0 20.15 15v-1.15zm16.3-1.7H3.85V5c0-.635.515-1.15 1.15-1.15h14c.635 0 1.15.515 1.15 1.15zm-6.564 5.7h-3.172l-.575 2.3h4.322z",
  clipRule: "evenodd"
})));
export default SvgDesktopComputer;